var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9298 16.2408L15.0005 16.3115L15.0712 16.2408L18.9512 12.3608C19.3008 12.0111 19.8778 12.0184 20.2302 12.3612C20.5807 12.7122 20.5806 13.2786 20.2298 13.6293L15.6398 18.2193C15.2888 18.5703 14.7221 18.5703 14.3712 18.2193L9.78118 13.6293C9.43023 13.2784 9.43023 12.7117 9.78118 12.3608C10.1321 12.0098 10.6988 12.0098 11.0498 12.3608L14.9298 16.2408Z",
    fill: "#14459B",
    stroke: "white",
    strokeWidth: 0.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29.5,
    y: 29.5,
    width: 29,
    height: 29,
    rx: 1.5,
    transform: "rotate(180 29.5 29.5)",
    stroke: "#ECECEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.3d341a8291bc5c5a9d2d04a9147eb5d2.svg";
export { ForwardRef as ReactComponent };